<template>
  <div class="particle">
    <el-divider></el-divider>
    <div class="title-style">
      <el-checkbox v-model="checked">风玫瑰图</el-checkbox>
      <el-popover
        placement="top-start"
        title=""
        width="300"
        trigger="hover"
        content="地图缩放等级小于15时(地图微站显示数值的等级)，不显示."
      >
        <i class="el-icon-info" slot="reference"></i>
      </el-popover>
    </div>
    <div class="content" v-show="checked">
      <div class="mode_selection">
        <el-radio-group v-model="stationType">
          <el-radio label="wzRadio">微站</el-radio>
          <el-radio label="bzRadio">标站</el-radio>
        </el-radio-group>
      </div>

      <div class="mode_selection" v-if="stationType == 'wzRadio'">
        <el-radio-group v-model="mode">
          <el-radio label="single">单参数</el-radio>
          <el-radio label="multi">关联分析</el-radio>
        </el-radio-group>
      </div>
      <el-form
        ref="form"
        :model="form"
        size="small"
        label-width="70px"
        style="margin-top: 12px"
      >
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="form.datetimerange"
            type="datetimerange"
            format="yyyy-MM-dd HH"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 280px"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="指标">
          <el-select v-model="form.norm" placeholder="请选择指标">
            <el-option
              v-for="item of sensortypes"
              :label="item.name"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="mode === 'multi'" label="粒径">
          <el-select v-model="form.particle" placeholder="请选择粒径">
            <el-option label="平均粒径" value="particle"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="粒径系数" style="margin-bottom: 0">
          <span>
            <el-slider
              show-input
              v-model="form.particleCoefficient"
              :min="0.1"
              :step="0.1"
            ></el-slider>
          </span>
        </el-form-item>
        <el-form-item label="叠加风向">
          <el-switch v-model="form.showDirection"></el-switch>
        </el-form-item>
        <!-- <el-form-item> -->
        <!-- <el-button type="primary" @click="onLoading">加载</el-button> -->
        <!-- <el-button @click="onReset()">重置</el-button> -->
        <!-- </el-form-item> -->
      </el-form>
    </div>

    <el-divider></el-divider>
  </div>
</template>

<script>
import moment from "moment";
import find from "lodash/find";
import cloneDeep from "lodash/cloneDeep";
import { zoomCircleSize } from "@/utils/common.js";
import { pickerOptions, defaultForm } from "./options";
import {
  drawWindDial,
  calculateMapPixelRadius,
  transformCoordinatesPoints,
  transformCoordinatesPolygon,
  getWindDirection,
  getWindSpeedM,
} from "./util";
import { get029Wind } from "@/api/api";
import { mapState } from "vuex";
// import data from "./data"
// 风玫瑰图只显示看pm参数
const sensortypes = G_SENSOR_DATA_TYPE_INFO.filter((item) =>
  ["pm25", "pm10"].includes(item.value)
);

export default {
  name: "AverageParticle",
  props: {
    map: {
      type: [Object, String],
      default: null,
    },
    colorType: {
      type: String,
      default: "static",
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 700,
    },
    city: {
      type: String,
      default: "莱芜",
    },
    offStations: {
      type: Array,
      default: () => [],
    },
    showOff: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mode: "single",
      pickerOptions,
      checked: false,
      form: cloneDeep(defaultForm),
      stationType: "wzRadio",
    };
  },
  computed: {
    ...mapState(["selectLevels"]),

    Intensity() {
      return new colorIntensity.getIntensity({
        dataType: this.currentSensor,
        min: this.min,
        max: this.max,
        colorType: this.colorType,
      });
    },
    sensortypes() {
      let types = cloneDeep(sensortypes);
      if (this.stationType == "wzRadio" && this.mode === "single") {
        let op = sensortypes.filter((item) => item.value === "pm10")[0];
        op = { ...op, label: "平均粒径", name: "平均粒径", value: "pm31_size" };
        types.push(op);
      }
      return types;
    },
    currentSensor() {
      if (this.form.norm === "pm31_size") {
        return "pm10";
      } else {
        return this.form.norm;
      }
    },
  },
  watch: {
    map() {
      this.init();
    },
    "form.datetimerange": {
      handler(newValue, oldValue) {
        const dayDiff = moment(newValue[1]).diff(moment(newValue[0]), "day");
        if (dayDiff > 90) {
          this.form = { ...this.form, datetimerange: oldValue };
          this.$message.warning("选择的时间范围不能大于90天");
        } else {
          this.get029WindData().then(() => {
            this.handleDrawData();
          });
        }
      },
    },
    "form.norm": {
      handler() {
        this.handleDrawData();
      },
    },
    "form.particle": {
      handler() {
        this.handleDrawData();
      },
    },
    "form.particleCoefficient": {
      handler() {
        this.handleDrawData();
      },
    },
    "form.showDirection": {
      handler() {
        this.handleDrawData();
      },
    },
    showOff() {
      this.handleDrawData();
    },
    checked() {
      if (this.checked) {
        this.get029WindData().then(() => {
          this.handleDrawData();
        });
      } else {
        this.handleDrawData();
      }
    },
    mode() {
      this.handleModeChange();
    },
    Intensity() {
      this.handleDrawData();
    },
    stationType() {
      this.get029WindData().then(() => {
        this.handleDrawData();
      });
    },
    selectLevels() {
      console.log("selectLevels--", this.selectLevels);
      this.handleDrawData();
    },
  },
  mounted() {
    // this.init()
    this.borderData = [];
    this.pointsData = [];
    this.minZoom = 14;
  },
  methods: {
    init() {
      // 风向盘canvas
      const windDialCanvasLayer = new BMap.CanvasLayer({
        update: this.drawWindDial,
        zIndex: -10,
        paneName: "markerPane",
      });
      this.map.addOverlay(windDialCanvasLayer);
      this.windDialCtx = windDialCanvasLayer.canvas.getContext("2d");
      // 选中圈点canvas
      const selectCanvasLayer = new BMap.CanvasLayer({
        update: this.drawSelectStatus,
        zIndex: 3,
      });
      this.map.addOverlay(selectCanvasLayer);
      this.selectCtx = selectCanvasLayer.canvas.getContext("2d");
      // 初始化mapv
      this.initMapvLayers();
    },
    initMapvLayers() {
      this.pointDataSet = new mapv.DataSet([]);
      this.borderDataSet = new mapv.DataSet([]);
      const _this = this;
      const options = {
        draw: "simple",
        zIndex: 3,
        methods: {
          click: function (item) {
            // 点击事件，返回对应点击元素的对象值
            if (item) {
              _this.openInfowindow(item.info);
            }
          },
          mousemove: function (item, e) {
            // 鼠标移动事件，对应鼠标经过的元素对象值
            if (item) {
              _this.map.setDefaultCursor("pointer");
              const coordinates = item.geometry.coordinates;
              const point = {
                lng: coordinates[0],
                lat: coordinates[1],
                size: item.size,
              };
              _this.drawSelectStatus(point);
            } else {
              _this.map.setDefaultCursor("default");
            }
          },
        },
      };
      const borderOptions = {
        draw: "simple",
        fillStyle: "transparent",
        strokeStyle: "rgba(55, 55, 250, 0.3)",
        lineWidth: 1,
        zIndex: 2,
        methods: {
          mousemove: function (item, e) {
            const zoom = _this.map.getZoom();
            if (zoom >= _this.minZoom) {
              var pt = turf.point([e.point.lng, e.point.lat]);
              let borderData = cloneDeep(_this.borderData);
              borderData = borderData.map((v) => {
                var poly = turf.polygon(v.geometry.coordinates);
                var inPolygon = turf.booleanPointInPolygon(pt, poly);
                if (inPolygon) {
                  v.fillStyle = "rgba(200, 200, 200, 0.3)";
                }
                return v;
              });
              _this.borderDataSet.set(borderData);
            }
          },
        },
      };
      this.pointsMapvLayer = new mapv.baiduMapLayer(
        this.map,
        this.pointDataSet,
        options
      );
      this.borderMapvLayer = new mapv.baiduMapLayer(
        this.map,
        this.borderDataSet,
        borderOptions
      );
      this.map.addEventListener("zoomend", () => {
        const zoom = this.map.getZoom();
        this.cirSize = zoomCircleSize[zoom];
        this.handleDrawData();
      });
    },
    onLoading() {
      this.handleDrawData();
    },
    onReset() {
      this.form = cloneDeep(defaultForm);
      this.handleDrawData();
    },
    decrease() {
      this.form.particleCoefficient--;
    },
    increase() {
      this.form.particleCoefficient++;
    },
    get029WindData() {
      const params = {};
      const [start_time, end_time] = this.form.datetimerange;
      params.start_time = moment(start_time).format("YYYY-MM-DD HH:mm:ss");
      params.end_time = moment(end_time).format("YYYY-MM-DD HH:mm:ss");
      params.city = this.city;
      params.type = this.stationType == "wzRadio" ? 3 : 5;
      params.stationType = this.stationType;

      this.openFullScreenLoading();
      return get029Wind(params)
        .then((res) => {
          this.windData = res.data.data;
          this.loading.close();
        })
        .catch((err) => {
          console.log(err);
          this.loading.close();
        });
    },
    handleDrawData() {
      this.borderData = [];
      this.pointsData = [];
      let drawData = cloneDeep(this.windData);
      if (this.windData && this.windData.length) {
        // 过滤离线设备
        if (!this.showOff) {
          drawData = drawData.filter(
            (item) => !this.offStations.includes(item.sn)
          );
        }
        if (this.stationType == "bzRadio") {
          drawData = drawData.filter(
            (item) =>
              this.selectLevels.indexOf(item.station_level) > -1 ||
              this.selectLevels.some(
                (element) => item.station_level_list.indexOf(element) > -1
              )
          );
        }

        drawData.forEach((item) => {
          // 站点坐标转换
          var gcj = coordtransform.wgs84togcj02(item.lng, item.lat);
          var bd = coordtransform.gcj02tobd09(gcj[0], gcj[1]);
          item.lng = bd[0];
          item.lat = bd[1];
          // 边界坐标转换
          item.coords = transformCoordinatesPolygon(item.coords);
          this.borderData.push({
            geometry: {
              type: "Polygon",
              coordinates: [item.coords],
            },
            sn: item.sn,
          });
          if (item.data.length) {
            // 散点坐标转换
            item.data = transformCoordinatesPoints(item.data);
            // 粒径系数
            const particleCoefficient = this.form.particleCoefficient;
            let size = particleCoefficient * this.cirSize * 0.2;
            item.data.forEach((point) => {
              const color = this.Intensity.bgcolor.getColor(
                point[this.form.norm]
              );
              if (this.mode === "multi") {
                size =
                  (point["pm31_size"] || 1) *
                  particleCoefficient *
                  this.cirSize *
                  0.025;
              }
              this.pointsData.push({
                geometry: {
                  type: "Point",
                  coordinates: [point.lng, point.lat],
                },
                fillStyle: color,
                info: { station: item.station, sn: item.sn, ...point },
                size,
              });
            });
          }
        });
      }
      this.drawData = drawData;
      this.drawWindBorder();
      this.drawWindPoints();
      this.drawWindDial();
    },
    // 绘制风的散点图
    drawWindPoints() {
      const zoom = this.map.getZoom();
      if (zoom >= this.minZoom && this.checked) {
        this.pointDataSet.set(this.pointsData);
        this.pointsMapvLayer.show();
      } else {
        this.pointsMapvLayer.hide();
      }
    },
    // 绘制边界
    drawWindBorder() {
      const zoom = this.map.getZoom();
      if (zoom >= this.minZoom && this.checked) {
        if (this.borderData.length > 2) {
          this.borderDataSet.set(this.borderData);
        } else {
          this.$message.warning("绘制边界数据不足");
        }
        this.borderMapvLayer.show();
      } else {
        this.borderMapvLayer.hide();
      }
    },
    // 绘制风向表盘
    drawWindDial() {
      this.clearWindDial();
      const zoom = this.map.getZoom();
      if (zoom >= this.minZoom && this.checked) {
        const showDirection = this.form.showDirection;
        if (showDirection) {
          this.drawData.forEach((station) => {
            // 散点图默认以5km/h风速映射的地图距离作为第一级（3级）半径, 其它图按照最大值的1.5倍作为最大半径
            // 1km/h对应地图实际距离为20米
            const max_val = 5;
            const distance = (max_val * 20) / 1000;
            const origin = {
              distance,
              lng: station.lng,
              lat: station.lat,
              map: this.map,
            };
            const centerRadius = calculateMapPixelRadius(origin);
            // 绘制
            drawWindDial({
              ctx: this.windDialCtx,
              n: 16,
              center: centerRadius,
            });
          });
        }
      }
    },
    // 清除风向表盘
    clearWindDial() {
      if (this.windDialCtx) {
        const width = this.windDialCtx.canvas.width;
        const height = this.windDialCtx.canvas.height;
        this.windDialCtx.clearRect(0, 0, width, height);
      }
    },
    // 绘制鼠标掠过圈点
    drawSelectStatus(point) {
      if (this.selectCtx) {
        this.selectCtx.clearRect(
          0,
          0,
          this.selectCtx.canvas.width,
          this.selectCtx.canvas.height
        );
        if (point) {
          var p = this.map.pointToPixel(new BMap.Point(point.lng, point.lat));
          const radius = point.size;
          this.selectCtx.beginPath();
          this.selectCtx.strokeStyle = "rgba(128, 128, 128, 0.8)";
          this.selectCtx.arc(p.x, p.y, radius, 0, 2 * Math.PI);
          this.selectCtx.stroke();
          this.selectCtx.closePath();
        }
      }
    },
    // 绘制弹窗
    openInfowindow(info) {
      if (infoWindow && infoWindow.isOpen()) {
        this.map.closeInfoWindow();
      }
      const opts = {
        width: 180, // 信息窗口宽度
        height: 140, // 信息窗口高度
        title: info.station, // 信息窗口标题
      };
      let time = "--";
      if (info.time) {
        time = moment(info.time * 1000).format("YYYY-MM-DD HH");
      }
      const op = find(this.sensortypes, (o) => o.value === this.form.norm);
      const windDirection = getWindDirection(info.wind_direction);
      let content = `
          <div class="s-content">${time}时</div>
          <div class="s-content">${op.name}：${info[op.value] || "--"}${
        op.unit
      }</div>
          <div class="s-content">平均粒径：${info["pm31_size"] || "--"}${
        op.unit
      }</div>
          <div class="s-content">风向：${windDirection}</div>
          <div class="s-content">风速：${getWindSpeedM(
            info.wind_speed
          )}m/s</div>
        `;
      if (this.mode === "single") {
        content = `
            <div class="s-content">${time}时</div>
            <div class="s-content">${op.name}：${info[op.value] || "--"}${
          op.unit
        }</div>
            <div class="s-content">风向：${windDirection}</div>
            <div class="s-content">风速：${getWindSpeedM(
              info.wind_speed
            )}m/s</div>
          `;
      }
      const infoWindow = new BMap.InfoWindow(content, opts); // 创建信息窗口对象
      const point = new BMap.Point(info.lng, info.lat);
      this.map.openInfoWindow(infoWindow, point); //开启信息窗口
    },
    openFullScreenLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    handleModeChange() {
      const flag = this.sensortypes
        .map((item) => item.value)
        .includes(this.form.norm);
      if (!flag) {
        this.form.norm = this.sensortypes[0].value;
      } else {
        this.handleDrawData();
      }
    },
  },
};
</script>

<style scoped>
.particle /deep/ .el-form-item,
.particle /deep/ .el-form-item--mini.el-form-item,
.particle /deep/ .el-form-item--small.el-form-item {
  margin-bottom: 10px;
}
.particle /deep/ .el-col {
  margin: 0;
}
.title-style {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.s-content {
  padding: 5px 0;
}
.mode_selection {
  width: 100%;
  padding: 8px 16px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/AverageParticle/index.vue